import React from 'react';
import {Provider} from "react-redux";
import MyPageContainer from "./container/MyPageContainer";
import configure from '../../store/configure';
import './MyPage.css';
import Layout from "../../component/layout/Layout";

const MyPage = () => {
    return (
        <Provider store={configure}>
            <Layout>
                <MyPageContainer/>
            </Layout>
        </Provider>
    );
};

export default MyPage;
